import React from 'react'
import GeoPicker from './GeoPicker'
import _DoubleDropdown from './DoubleDropdown'
import _SingleDropdown from './SingleDropdown'

const DoubleDropdown = (props) => {
  return <GeoPicker Component={_DoubleDropdown} {...props} />
}
const SingleDropdown = (props) => {
  return <GeoPicker Component={_SingleDropdown} {...props} />
}

export { SingleDropdown, DoubleDropdown, SingleDropdown as GeoPicker }
